import React from "react"
import styled from "styled-components"

import FormattedMessage from "@irati/utils/lang"

import Flex from "../../Flex"
import Button from "../../Button"
import {Body, Label} from "../../Typography"

const StyledLabel = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: initial;
`

interface RowProps {
  isFocused: boolean,
  isDisabled?: boolean
}

const FlexRow = styled(Flex)<RowProps>`
  background-color: ${({theme, isFocused}) => (isFocused ? theme.colors.utility.highlight : "none")};
  padding: ${({theme}) => theme.spacing.oneAndHalf};
  &:hover {
    background-color: transparent;
  }
`

const DisabledHeaderOption = (
  {label, onClearAllClick, cleanUpText, useBody}:
  {label: string, onClearAllClick?: () => void, cleanUpText?: string, useBody?: boolean}) => {
  const buttonText = cleanUpText || "platform.button.clearAll"

  return (
    <FlexRow justifyContent="space-between" alignItems="center">
      {useBody
        ? <Body>{label}</Body>
        :  <StyledLabel><Label>{label}</Label></StyledLabel>}
      {onClearAllClick &&
        <Button tertiary onClick={onClearAllClick}>
          <FormattedMessage id={buttonText} />
        </Button>}
    </FlexRow>
  )
}

export default DisabledHeaderOption
